<template>
    <div class="micro-app-ams">
        <micro-app
            v-show="storeInfo && storeInfo.user && storeInfo.user.userCode"
            name="outPage"
            :url="config.microAmsUrl"
            baseroute='/outPage'
            iframe
            :data="storeInfo"
            keep-alive
            >
        </micro-app>
    </div>
</template>
<script>
import config from '@/config/user.env';
import microApp from '@micro-zoe/micro-app';
import { mapState, mapGetters } from 'vuex';
import { getSupplierContactsInfos } from '../index/api/user.js';

export default {
    data() {
        return {
            config,
            storeInfo: {},
            currentContactsMobile: null,
            styleLink: null
        };
    },
    computed: {
        ...mapState(['contactsMobile']),
        ...mapGetters(['user', 'authority', 'currentTenant', 'appId', 'tenantInfo', 'appList', 'applicationCode', 'supplier', 'btnPermissions'])
    },
    methods: {
        initVxeTableCss() {
            // 子应用的vxe-table版本和主应用的版本不同，且无法同一版本，所以需要单独引入样式
            return new Promise((resolve, reject) => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = `${window.location.origin}/vxe-table/style.min.css`;
                // link.href = require('./microApp/vxe-table/style.min.css');
                link.onload = () => {
                    this.styleLink = link; // 保存链接引用
                    resolve();
                };
                link.onerror = (error) => {
                    reject(error);
                };
                document.head.appendChild(link);
            });
        },
        async initPage() {
            if (!this.contactsMobile) {
                await this.getMobile();
            }
            this.$nextTick(() => {
                microApp.setData('outPage', { path: this.$route.path, query: this.$route.query || {} });
            });
            const {
                user,
                authority,
                currentTenant,
                appId,
                tenantInfo,
                appList,
                applicationCode,
                supplier,
                btnPermissions,
                contactsMobile,
                currentContactsMobile } = this;

            // 这里的一些参数除了重点说明的两个一般物流的项目都会有
            this.storeInfo = {
                user,
                authority,
                currentTenant,
                appId,
                tenantInfo,
                appList,
                applicationCode,
                supplier,
                btnPermissions,
                contactsMobile: contactsMobile || currentContactsMobile
            };
        },
        getMobile() {
            return getSupplierContactsInfos({ userCode: this.user.userCode }).then(res => {
                if (res && +res.code === 0 && res.data.list.length) {
                    this.currentContactsMobile = res.data.list[0].contactsMobile;
                }
            }).catch(err => {});
        }
    },
    watch: {
        $route() {
            this.initPage();
        }
    },
    mounted() {
        this.initPage();
        this.initVxeTableCss();
    },
    beforeDestroy() {
        if (this.styleLink) {
            document.head.removeChild(this.styleLink); // 卸载样式
            this.styleLink = null; // 清空引用
        }
    }
};
</script>
<style lang="less" scoped>
@import './microApp/microappTheme.less';
.micro-app-ams {
    micro-app[name="outPage"] {
        micro-app-body {
            height: 100%;
            .column-config-icon {
                width: 20px;
                &>i {
                    width: 20px;
                    height: 20px;
                    &>svg {
                        width: 100%;
                        height: 100%;
                        color: #07f;
                    }
                }
            }
        }
    }
}

</style>
